export const addThumbToUrl = (url: string): string => {
  const urlParts = url.split('.');
  const extension = urlParts.pop();
  const modifiedUrl = urlParts.join('.') + '-thumb.' + extension;
  return modifiedUrl;
};
